import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { auth, db } from '../../firebase';
import "../../App.css";
import { collection, query, orderBy, onSnapshot, getDoc, doc, limit } from 'firebase/firestore';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@mui/material";
import Menu from "../../panel/Menu";

const colors = {
    darkGreen: '#06362D',
    calPolyGreen: '#155332',
    vanilla: '#DEE2B1',
    gold: '#FFD500',
    goldenrod: '#D1A505'
};

export default function Logindetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: colors.calPolyGreen,
        color: colors.vanilla,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [logindetails, setlogindetails] = useState([]);
    const [searchText, setsearchText] = useState("");

    useEffect(() => {
        if (searchText === '') {
            fetchData1();
        } else {
            fetchData2();
        }
    }, [searchText]);

    useEffect(() => {
        const unsub = auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid();
        });
        return () => unsub();
    }, []);

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false);
                }
            }
        }
    };

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'logindetails'), orderBy('createdTime', 'desc'), limit(200));
            onSnapshot(q, (querySnapshot) => {
                setlogindetails(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    };

    const fetchData2 = async () => {
        try {
            const filteredData = logindetails.filter((item) =>
                item.data.username.toUpperCase().includes(searchText.toUpperCase())
            );
            setlogindetails(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    return (
        <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: colors.darkGreen, color: colors.vanilla, p: { xs: 2, md: 4 } }}>
            <Box component="main" sx={{ flexGrow: 1, maxWidth: "1600px", margin: "0 auto", width: "100%" }}>
                <Menu />
                <div className="content-wrapper" style={{ backgroundColor: 'transparent' }}>
                    <br />

                    <section className="content">
                        <div className="container-fluid p-0">
                            <Typography
                                variant="h5"
                                fontWeight={800}
                                mb={3}
                                sx={{ color: colors.vanilla }}
                            >
                                Login Details
                            </Typography>

                            <Card sx={{ borderRadius: 3, border: `1px solid ${colors.goldenrod}`, bgcolor: colors.calPolyGreen, color: colors.vanilla, boxShadow: "0 4px 20px 0 rgba(0,0,0,0.3)" }}>
                                <CardContent sx={{ p: 3 }}>
                                    <div className="container-fluid p-0 mb-3">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <TextField
                                                    type="search"
                                                    label="Search User"
                                                    value={searchText}
                                                    onChange={(e) => setsearchText(e.target.value)}
                                                    fullWidth
                                                    size="small"
                                                    InputLabelProps={{ style: { color: colors.vanilla } }}
                                                    InputProps={{ style: { color: colors.vanilla } }}
                                                    sx={{ 
                                                        "& .MuiOutlinedInput-root": { 
                                                            borderRadius: "8px",
                                                            backgroundColor: colors.darkGreen,
                                                            "& fieldset": { borderColor: colors.goldenrod },
                                                            "&:hover fieldset": { borderColor: colors.gold },
                                                            "&.Mui-focused fieldset": { borderColor: colors.gold }
                                                        } 
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <TableContainer component={Paper} elevation={0} sx={{ borderRadius: "8px", border: `1px solid ${colors.goldenrod}`, backgroundColor: "transparent" }}>
                                        <Table size="small">
                                            <TableHead sx={{ bgcolor: colors.darkGreen }}>
                                                <TableRow>
                                                    <TableCell width={80} sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Sr No</TableCell>
                                                    <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>User Name</TableCell>
                                                    <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Login Time</TableCell>
                                                    <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Platform</TableCell>
                                                    <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>Screen Ratio</TableCell>
                                                    <TableCell sx={{ color: colors.vanilla, fontWeight: 700, fontSize: '0.75rem' }}>User Agent</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {logindetails.map((item, num = 1) => (
                                                    <TableRow key={num + 1} hover sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' } }}>
                                                        <TableCell width={80} sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{num + 1}</TableCell>
                                                        <TableCell sx={{ color: colors.gold, fontWeight: 600, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.data.username}</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, opacity: 0.9, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.data.createdTime}</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.data.systemDetails.platform}</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.data.systemDetails.screenHeight} X {item.data.systemDetails.screenWidth}</TableCell>
                                                        <TableCell sx={{ color: colors.vanilla, opacity: 0.8, borderBottom: `1px solid rgba(222,226,177,0.1)` }}>{item.data.systemDetails.userAgent}</TableCell>
                                                    </TableRow>
                                                ))}

                                                {!logindetails.length && (
                                                    <TableRow>
                                                        <TableCell colSpan={6} align="center" sx={{ py: 4, color: colors.vanilla, opacity: 0.7 }}>
                                                            No login details found
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </CardContent>
                            </Card>
                        </div>
                    </section>
                </div>
            </Box>
        </Box>
    );
}